<template>
  <transition :name="transition">
    <div
      tabindex="0"
      class="vld-overlay is-active"
      :class="{ 'is-full-page': isFullPage }"
      v-show="isActive"
      :aria-busy="isActive"
      aria-label="Loading"
      :style="{ zIndex: this.zIndex }"
    >
      <div
        class="vld-background"
        @click.prevent="cancel"
        :style="{ background: this.backgroundColor, opacity: this.opacity }"
      ></div>
      <div>
        <slot name="before"></slot>
        <slot name="default">
          <v-img :src="loadingIndicatorUrl" />
          <!-- <p class="animation" :color="color" :width="width" :height="height">CREATIVE</p>
          <p class="message" :width="width" :height="height">{{message}}</p>-->
        </slot>
        <slot name="after"></slot>
      </div>
    </div>
  </transition>
</template>

<script>
import { removeElement, HTMLElement } from "./helpers";
import trapFocusMixin from "./trapFocusMixin";
import { stringUtil } from "@/models/stringUtil.ts";
export default {
  name: "vue-loading",
  mixins: [trapFocusMixin],
  computed: {
    loadingIndicatorUrl() {
      return stringUtil.createUrl("tools/loading_circle.gif");
    },
  },
  props: {
    active: Boolean,
    message: String,
    programmatic: Boolean,
    container: [Object, Function, HTMLElement],
    isFullPage: {
      type: Boolean,
      default: false,
    },
    transition: {
      type: String,
      default: "fade",
    },
    /**
     * Allow user to hide the loader
     */
    canCancel: Boolean,
    /**
     * Do something on cancel
     */
    onCancel: {
      type: Function,
      default: () => {},
    },
    color: String,
    backgroundColor: String,
    opacity: Number,
    width: Number,
    height: Number,
    zIndex: Number,
    loader: {
      type: String,
      default: "spinner",
    },
  },
  data() {
    return {
      // Don't mutate the prop
      isActive: this.active,
    };
  },
  beforeMount() {
    // Insert the component in DOM when called programmatically
    if (this.programmatic) {
      if (this.container) {
        this.isFullPage = false;
        this.container.appendChild(this.$el);
      } else {
        document.body.appendChild(this.$el);
      }
    }
  },
  mounted() {
    // Activate immediately when called programmatically
    if (this.programmatic) {
      this.isActive = true;
    }
    document.addEventListener("keyup", this.keyPress);
  },
  methods: {
    /**
     * Proxy to hide() method.
     * Gets called by ESC button or when click outside
     */
    cancel() {
      if (!this.canCancel || !this.isActive) return;
      this.hide();
      this.onCancel.apply(null, arguments);
    },
    /**
     * Hide and destroy component if it's programmatic.
     */
    hide() {
      this.$emit("hide");
      this.$emit("update:active", false);
      // Timeout for the animation complete before destroying
      if (this.programmatic) {
        this.isActive = false;
        setTimeout(() => {
          this.$destroy();
          removeElement(this.$el);
        }, 150);
      }
    },
    /**
     * Key press event to hide on ESC.
     *
     * @param event
     */
    keyPress(event) {
      // todo keyCode is deprecated
      if (event.keyCode === 27) {
        this.cancel();
      }
    },
  },
  watch: {
    active(value) {
      this.isActive = value;
    },
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.keyPress);
  },
};
</script>
<style scoped>
.vld-overlay {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  align-items: center;
  display: none;
  justify-content: center;
  overflow: hidden;
  z-index: 1;
  background: #fff;
}

.vld-overlay.is-active {
  display: flex;
}

.vld-overlay.is-full-page {
  z-index: 999;
  position: fixed;
}

.vld-overlay .vld-background {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #fff;
  opacity: 0.5;
}

.vld-overlay .vld-icon,
.vld-parent {
  position: relative;
}

.message {
  text-align: center;
}

.animation {
  position: relative;
  font-family: sans-serif;
  text-transform: uppercase;
  font-size: 3em;
  letter-spacing: 4px;
  overflow: hidden;
  background: linear-gradient(90deg, #000, #555, #000);
  background-repeat: no-repeat;
  /* background-size: 80%; */
  animation: animate 2s linear infinite;
  -webkit-background-clip: text;
  -webkit-text-fill-color: rgba(255, 255, 255, 0);
}

@keyframes animate {
  0%,
  20%,
  60%,
  80%,
  100% {
    transform: translateY(0);
    transform: scale(1);
  }
  70% {
    /* transform: translateY(-10px); */
    transform: scale(1.1);
  }
  90% {
    /* transform: translateY(-10px); */
    transform: scale(1.1);
  }
}
</style>
